import React, {Component} from 'react';
import { Link } from 'react-router-dom';

// Images
import bnrImg from "../../images/banner/bnr5.jpg";
import blogGridPic1 from "../../images/blog/grid/pic1.jpg";
import blogGridPic2 from "../../images/blog/grid/pic2.jpg";
import blogGridPic3 from "../../images/blog/grid/pic3.jpg";
import blogGridPic4 from "../../images/blog/grid/pic4.jpg";
import blogGridPic5 from "../../images/blog/grid/pic5.jpg";
import blogGridPic6 from "../../images/blog/grid/pic6.jpg";
import authorThumbPic1 from "../../images/testimonials/pic1.jpg";
import authorThumbPic2 from "../../images/testimonials/pic2.jpg";
import authorThumbPic3 from "../../images/testimonials/pic3.jpg";
import authorThumbPic4 from "../../images/testimonials/pic4.jpg";
import authorThumbPic5 from "../../images/testimonials/pic5.jpg";
import authorThumbPic6 from "../../images/testimonials/pic6.jpg";

const content = [
	{
		thumb: blogGridPic1,
		authorThumb: authorThumbPic1,
		authorName: "Mark John",
		title: "Is Changing Transmission Fluid Necessary?",
		blogText: "It mostly comes down to heat. Heat is the biggest killer of your transmission, partly because it’s the biggest killer of your transmission fluid. The fluid ...",
	},
	{
		thumb: blogGridPic2,
		authorThumb: authorThumbPic2,
		authorName: "Merry Desulva",
		title: "Boost Your Mileage: Key Maintenance Tips",
		blogText: "Learn how consistent maintenance not only extends the life of your car but also significantly enhances its fuel efficiency and performance...",
	},
	{
		thumb: blogGridPic3,
		authorThumb: authorThumbPic3,
		authorName: "Thomas deo",
		title: "Car Transmission Explained",
		blogText: "Dive into the complexities of your vehicle's transmission system to grasp its critical role in ensuring smooth and efficient performance...",
	},
	{
		thumb: blogGridPic4,
		authorThumb: authorThumbPic4,
		authorName: "Merry Desulva",
		title: "DIY Car Fixes: Easy Home Repairs",
		blogText: "Discover cost-effective and straightforward DIY maintenance tips that can help you keep your car running smoothly without frequent ...",
	},
	{
		thumb: blogGridPic5,
		authorThumb: authorThumbPic5,
		authorName: "Thomas deo",
		title: "Strategies for Reducing Car Service Costs",
		blogText: "Uncover expert strategies for reducing your car maintenance expenses, ensuring you get the best value without compromising service ...",
	},
	{
		thumb: blogGridPic6,
		authorThumb: authorThumbPic6,
		authorName: "Mark John",
		title: "The Future of Car Service: Trends and Innovation",
		blogText: "Explore the latest advancements in car maintenance technology and how they are set to transform the way we care for our vehicles in the ...",
	},
]

class BlogGrid extends Component{

	render(){
		return (
			<>
				<div className="page-content bg-gray">

					<div className="page-banner ovbl-dark" style={{backgroundImage: "url("+bnrImg+")"}}>
						<div className="container">
							<div className="page-banner-entry text-center">
								<h1><span>Featured Articles</span></h1>
								<nav aria-label="breadcrumb" className="breadcrumb-row">
									<ul className="breadcrumb">
										<li className="breadcrumb-item"><Link to="/"><i className="las la-home"></i>Home</Link></li>
										<li className="breadcrumb-item active" aria-current="page">Blog</li>
									</ul>
								</nav>
							</div>
						</div>
					</div>

					<section className="section-area section-sp2">
					   <div className="container">
							<div className="row">
								{content.map((item, index) =>(
									<div key={index} className="col-xl-4 col-md-6">
										<div className="blog-card style-1 bg-white shadow">
											<div className="post-media">
												<a href="why-does-the-transmission-fluid-need-to-be-changed"><img src={item.thumb} alt=""/></a>
											</div>
											<div className="post-info">
												<h4 className="post-title"><Link to="/why-does-the-transmission-fluid-need-to-be-changed">{item.title}</Link></h4>
												<div className="post-content">
													<p className="mb-0">{item.blogText}</p>
												</div>
												<ul className="post-meta">
													<li className="author"><img src={item.authorThumb} alt=""/>By <Link to="#">{item.authorName}</Link></li>
													<li className="date"><Link to="#">15 Feb 2024</Link></li>
												</ul>
											</div>
										</div>
									</div>
								))}
							</div>
							<div className="row">
								<div className="col-lg-12">
									<div className="pagination-bx text-center clearfix">
										<ul className="pagination">
											<li className="previous"><Link to="#">Prev</Link></li>
											<li className="active"><Link to="#">1</Link></li>
											<li><Link to="#">2</Link></li>
											<li><Link to="#">3</Link></li>
											<li className="next"><Link to="#">Next</Link></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</section>

				</div>

			</>
		);
	}
}

export default BlogGrid;
